import { parseApiError } from './apiError';

/** Une ligne de la table `api_logs` : un appel à l'API et sa réponse. */
export interface ApiLogEntry {
  id: number;
  timestamp: string;
  method: string;
  route: string;
  status: number | null;
  body: unknown;
  user_id: string | null;
  response: unknown;
  ip: string | null;
  user_agent: string | null;
  service: string | null;
  execution_time_ms: number | null;
  /** Prénom et nom du compte, quand l'appel en avait un. */
  user_name?: string | null;
}

export interface ApiLogsPage {
  logs: ApiLogEntry[];
  pagination: { total: number; limit: number; offset: number; hasMore: boolean };
  /** Compteurs des pastilles, sur les dernières 24 h, sans filtre. */
  last_24h?: { server_errors: number; refused: number; slow: number };
}

export interface ApiLogsFilters {
  /** 400 : erreurs seulement ; absent : tous les appels. */
  minStatus?: number;
  maxStatus?: number;
  /** Requêtes lentes : durée minimale en millisecondes. */
  minMs?: number;
  status?: number;
  method?: string;
  search?: string;
  userId?: string;
  limit: number;
  offset: number;
}

export const getApiLogs = async (token: string, filters: ApiLogsFilters): Promise<ApiLogsPage> => {
  const params = new URLSearchParams({ limit: String(filters.limit), offset: String(filters.offset) });
  if (filters.minStatus) params.set('min_status', String(filters.minStatus));
  if (filters.maxStatus) params.set('max_status', String(filters.maxStatus));
  if (filters.minMs) params.set('min_ms', String(filters.minMs));
  if (filters.status) params.set('status', String(filters.status));
  if (filters.method) params.set('method', filters.method);
  if (filters.search) params.set('search', filters.search);
  if (filters.userId) params.set('user_id', filters.userId);

  const res = await fetch(`${process.env.REACT_APP_API_URL}api/admin/logs?${params}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};
